/* sxg-bundle.js — behaviour for blocks/sxg-bundle.liquid.

   Progressive enhancement, same contract as sxg-collab.js: every tier, price,
   swatch and size is already in the DOM from Liquid. This file only toggles
   [hidden]/aria-pressed and reads data-* off nodes the server wrote. It never
   builds a size or a price, so it can never show one Shopify does not have.

   WHY THE SUBMIT IS TAKEN AT CAPTURE (the expensive lesson, re-learned here):
   UpCart's app-embed installs a global add-to-cart interceptor. On the home
   page it caught the click BEFORE any submit event fired and re-serialised the
   form with new FormData(form) — which drops the submitter's name/value, so
   `id` was never sent and the button silently did nothing. See the long note in
   sxg-collab.js. This form is worse for that interceptor, not better: there is
   no single `id` to find at all, because a bundle is 2-3 DIFFERENT line items.
   So the click is taken in the CAPTURE phase and stopImmediatePropagation()
   keeps UpCart out. The listener is scoped to this block's own button.

   The drawer is UpCart, not a theme section: upcartOpenCart / upcartRefreshCart. */
(function () {
  var root = document.querySelector('[data-sxg-bundle]');
  if (!root) return;

  var form = root.querySelector('[data-sxg-bundle-form]');
  if (!form) return;
  var atc = root.querySelector('[data-sxg-atc]');
  var atcText = root.querySelector('[data-sxg-atc-text]');
  var errEl = root.querySelector('[data-sxg-err]');
  var setOneEls = root.querySelectorAll('[data-sxg-set-one]');
  var productId = root.getAttribute('data-product-id');

  // Set one is NOT re-picked here — it mirrors Horizon's own variant picker, so
  // there is one source of truth for it on the page. Seeded server-side.
  var setOneVariant = root.getAttribute('data-set-one-variant');

  var PICK_HINT = atcText ? atcText.textContent.trim() : 'Choose color & size';

  // ------------------------------------------------------------------- tiers
  function selectedTierInput() {
    return root.querySelector('[data-sxg-tier-input]:checked');
  }

  function syncTierBoxes() {
    var checked = selectedTierInput();
    var boxes = root.querySelectorAll('[data-sxg-tier]');
    for (var i = 0; i < boxes.length; i++) {
      var input = boxes[i].querySelector('[data-sxg-tier-input]');
      boxes[i].classList.toggle('is-selected', input === checked);
    }
  }

  // ------------------------------------------------------------------- slots
  // A slot is one EXTRA set (set two, set three). Set one is never a slot.
  function activeSlots() {
    var checked = selectedTierInput();
    if (!checked) return [];
    var tier = checked.value;
    var panel = root.querySelector('[data-sxg-panel="' + tier + '"]');
    if (!panel) return [];
    return Array.prototype.slice.call(panel.querySelectorAll('[data-sxg-slot]'));
  }

  function slotVariant(slot) {
    var size = slot.querySelector('[data-sxg-size][aria-pressed="true"]');
    return size ? size.getAttribute('data-variant-id') : null;
  }

  function chooseSwatch(slot, swatch) {
    var all = slot.querySelectorAll('[data-sxg-swatch]');
    for (var i = 0; i < all.length; i++) {
      all[i].setAttribute('aria-pressed', String(all[i] === swatch));
    }

    var pid = swatch.getAttribute('data-product-id');

    // Show this colorway's size row, hide the others. Every row was rendered
    // by Liquid; none is built here.
    var rows = slot.querySelectorAll('[data-sxg-sizes]');
    for (var j = 0; j < rows.length; j++) {
      var match = rows[j].getAttribute('data-sxg-sizes') === pid;
      rows[j].hidden = !match;
      if (!match) {
        // Changing colorway invalidates the size: a Medium in one colorway is
        // a different variant id, and silently carrying the choice across would
        // add the wrong one.
        var pressed = rows[j].querySelectorAll('[data-sxg-size][aria-pressed="true"]');
        for (var k = 0; k < pressed.length; k++) pressed[k].setAttribute('aria-pressed', 'false');
      }
    }

    var thumbs = slot.querySelectorAll('[data-sxg-thumb]');
    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].hidden = thumbs[t].getAttribute('data-sxg-thumb') !== pid;
    }

    var activeRow = slot.querySelector('[data-sxg-sizes="' + pid + '"]');
    var stillPressed = activeRow && activeRow.querySelector('[data-sxg-size][aria-pressed="true"]');
    if (!stillPressed) clearSlotSize(slot);

    paintSlotChoice(slot);
  }

  function clearSlotSize(slot) {
    var pressed = slot.querySelectorAll('[data-sxg-size][aria-pressed="true"]');
    for (var i = 0; i < pressed.length; i++) pressed[i].setAttribute('aria-pressed', 'false');
  }

  function chooseSize(slot, btn) {
    var row = btn.parentNode;
    var all = row.querySelectorAll('[data-sxg-size]');
    for (var i = 0; i < all.length; i++) all[i].setAttribute('aria-pressed', String(all[i] === btn));
    paintSlotChoice(slot);
  }

  function paintSlotChoice(slot) {
    var swatch = slot.querySelector('[data-sxg-swatch][aria-pressed="true"]');
    var size = slot.querySelector('[data-sxg-size][aria-pressed="true"]');
    var out = slot.querySelector('[data-sxg-slot-choice]');
    var hint = slot.querySelector('[data-sxg-slot-hint]');

    var parts = [];
    if (swatch) parts.push(swatch.getAttribute('data-label'));
    if (size) parts.push(size.getAttribute('data-label'));
    if (out) out.textContent = parts.join(' · ');

    // The hint only nags while the slot is genuinely incomplete.
    if (hint) hint.hidden = !!(swatch && size);

    // Liquid renders the first colorway's thumb visible so the row is never an
    // empty grey box. Until a swatch is actually pressed that image is a
    // placeholder, not a choice, and it is dimmed to say so.
    slot.classList.toggle('is-chosen', !!swatch);
  }

  // -------------------------------------------------------------- the button
  function refresh() {
    syncTierBoxes();

    var checked = selectedTierInput();
    if (!checked || !atc || !atcText) return;

    var slots = activeSlots();
    var missing = 0;
    for (var i = 0; i < slots.length; i++) {
      if (!slotVariant(slots[i])) missing++;
    }

    var qty = Number(checked.getAttribute('data-extra')) + 1;
    var unit = qty === 1 ? root.getAttribute('data-unit-singular') : root.getAttribute('data-unit-plural');

    if (missing > 0) {
      atc.disabled = true;
      atcText.textContent = PICK_HINT;
      return;
    }

    atc.disabled = false;
    var was = checked.getAttribute('data-was-money');
    var now = checked.getAttribute('data-total-money');
    atcText.innerHTML = '';
    atcText.appendChild(document.createTextNode('Add ' + qty + ' ' + unit + ' · '));
    if (was) {
      var s = document.createElement('s');
      s.textContent = was;
      atcText.appendChild(s);
      atcText.appendChild(document.createTextNode(' '));
    }
    atcText.appendChild(document.createTextNode(now));
  }

  // ------------------------------------------------------------------ wiring
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-sxg-tier-input]')) {
      if (errEl) errEl.textContent = '';
      refresh();
    }
  });

  root.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-sxg-swatch]');
    if (swatch) {
      chooseSwatch(swatch.closest('[data-sxg-slot]'), swatch);
      if (errEl) errEl.textContent = '';
      refresh();
      return;
    }
    var size = e.target.closest('[data-sxg-size]');
    if (size && !size.disabled) {
      chooseSize(size.closest('[data-sxg-slot]'), size);
      if (errEl) errEl.textContent = '';
      refresh();
    }
  });

  // Set one follows Horizon's variant picker. ThemeEvents.variantUpdate.
  document.addEventListener('variant:update', function (e) {
    var d = e.detail || {};
    var resource = d.resource;
    // Combined listings / recommendation cards fire this too — only take ours.
    if (d.data && d.data.productId && String(d.data.productId) !== String(productId)) return;
    if (!resource || !resource.id) return;

    setOneVariant = String(resource.id);

    var label = resource.title || (resource.options && resource.options.join(' · '));
    if (label) {
      for (var i = 0; i < setOneEls.length; i++) setOneEls[i].textContent = label;
    }
    if (errEl) errEl.textContent = '';
  });

  // --------------------------------------------------------------- add to cart
  // 2026-09-03: the drawer is Horizon's NATIVE <cart-drawer-component>, not
  // UpCart -- that app embed is disabled on the live theme, so upcartOpenCart
  // was undefined, this returned false, and the caller's hard-navigation
  // fallback fired on EVERY add. Ruling 2026-09-03 (Derrick): the drawer
  // opens, and the shopper never leaves the page they are on.
  // UpCart is still tried first so re-enabling the app just works.
  function openCart() {
    try {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return true; }
    } catch (err) { /* fall through to the native drawer */ }
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      try {
        if (typeof drawer.open === 'function') { drawer.open(); return true; }
        if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
      } catch (err) { /* fall through */ }
    }
    return false;
  }

  function submitBundle() {
    if (!setOneVariant) {
      if (errEl) errEl.textContent = 'Choose a size above first.';
      return;
    }
    if (form.getAttribute('aria-busy') === 'true') return;   // double-tap guard

    var ids = [setOneVariant];
    var slots = activeSlots();
    for (var i = 0; i < slots.length; i++) {
      var v = slotVariant(slots[i]);
      if (!v) return;                     // refresh() should have blocked this
      ids.push(v);
    }

    // Two sets in the SAME size and colorway are one line item of qty 2, not
    // two lines of qty 1 — otherwise Shopify merges them anyway and the cart
    // disagrees with what the shopper just saw.
    var merged = {};
    for (var j = 0; j < ids.length; j++) merged[ids[j]] = (merged[ids[j]] || 0) + 1;
    var items = Object.keys(merged).map(function (id) {
      return { id: Number(id), quantity: merged[id] };
    });

    form.setAttribute('aria-busy', 'true');
    if (errEl) errEl.textContent = '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (r.ok) return r.json();
        // Shopify puts the real reason in `description` on a rejection — sold
        // out, or an inventory race between render and click. Surface THAT.
        return r.json().then(function (jsonBody) {
          throw new Error(jsonBody.description || jsonBody.message || 'HTTP ' + r.status);
        });
      })
      .then(function () {
        form.removeAttribute('aria-busy');
        try {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { sourceId: 'sxg-bundle', data: { source: 'sxg-bundle' } }
          }));
        } catch (err) { /* the theme's own cart icon is a nicety, not the job */ }
        // Drawer-only by ruling: NEVER navigate to /cart. If the drawer is
        // absent the shopper stays put with a refreshed cart bubble.
        openCart();
      })
      .catch(function (ex) {
        form.removeAttribute('aria-busy');
        if (errEl) errEl.textContent = ex.message || 'Could not add that bundle.';
      });
  }

  // Capture phase + stopImmediatePropagation: see the header note. Without this
  // UpCart's interceptor eats the click and posts a form with no `id` in it.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sxg-atc]');
    if (!btn || !root.contains(btn) || btn.disabled) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    submitBundle();
  }, true);

  // Enter inside the form must not post natively either.
  form.addEventListener('submit', function (e) {
    if (atc && atc.disabled) { e.preventDefault(); return; }
    e.preventDefault();
    submitBundle();
  });

  refresh();
})();
